/**
 * Main entry point
 *
 * Renders the App component
 */

import { render } from 'preact';
import { App } from './App';
import './style.css';

const root = document.getElementById('app');

if (root) {
  render(<App />, root);
} else {
  console.error('Root element not found');
}
